import { createSlice } from '@reduxjs/toolkit';

import { IMAGE_SLICE_NAME } from './constants';

export const slice = createSlice({
    name: IMAGE_SLICE_NAME,
    initialState: {
        list: null,
        error: null,
        loading: false,
    },
    reducers: {
        list: (state, action) => {
            const currentList = state.list && state.list.images ? { ...state.list.images } : {};
            state.list = { images: { ...currentList, ...action.payload.images } };
        },
        loading: (state, action) => {
            const currentLoading = state.loading && state.loading.loadingImages ? { ...state.loading.loadingImages } : {};
            state.loading = { loadingImages: { ...currentLoading, ...action.payload.loadingImages } };
        },
        error: (state, action) => {
            const currentError = state.error && state.error.errorImages ? { ...state.error.errorImages } : {};
            state.error = { errorImages: { ...currentError, ...action.payload.errorImages } };
        },
    },
});

export const list = (state) => state[IMAGE_SLICE_NAME].list;
export const loading = (state) => state[IMAGE_SLICE_NAME].loading;
export const error = (state) => state[IMAGE_SLICE_NAME].error;
export default slice.reducer;
